<template>
  <div class="fav-page" dir="rtl">

    <h1 class="fav-page__title">המועדפים שלי</h1>

    <!-- Empty state — shown when load is done and list is empty -->
    <div v-if="loaded && items.length === 0" class="fav-page__empty" role="status">
      <div class="fav-page__empty-icon" aria-hidden="true">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
          <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
        </svg>
      </div>
      <h2 class="fav-page__empty-heading">אין פריטים שמורים</h2>
      <p class="fav-page__empty-body">פריטים שתוסיפו למועדפים יופיעו כאן.</p>
      <ui-button variant="primary" size="lg" @click="$router.push('/')">
        גלו תוכן
      </ui-button>
    </div>

    <!-- Items grid -->
    <section
      v-else-if="items.length > 0"
      class="fav-page__grid"
      aria-label="פריטים שמורים"
    >
      <item-tpl
        v-for="item in items"
        :key="item.id"
        :item="item"
      />
    </section>

  </div>
</template>

<script>
import itemTpl from './item_tpl.vue';
import UiButton from './ui/Button.vue';

export default {
  components: { itemTpl, UiButton },

  data() {
    return {
      items: [],
      loaded: false,
    };
  },

  created() {
    this.api_call({
      url: 'favorites',
      onComplete: (data) => {
        this.items = data.data.data.items;
        this.loaded = true;
      },
    });
  },
};
</script>

<style scoped lang="scss">
/* ── Page wrapper ── */
.fav-page {
  background: var(--color-bg);
  min-height: 100vh;
  padding-block-start: var(--space-8);
  padding-block-end: var(--space-12);
}

/* ── Page title — title/lg §1.2 ── */
.fav-page__title {
  font-size: 28px;
  font-weight: 700;
  line-height: 34px;
  letter-spacing: -0.4px;
  color: var(--color-text);
  font-family: var(--font-hebrew);
  text-align: start;
  margin-block-start: 0;
  margin-block-end: var(--space-8);
  padding-inline: var(--space-8);
}

/* ── Items grid — sized for 16:9 thumbs ── */
.fav-page__grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: var(--space-5) var(--space-4);
  padding: var(--space-4) var(--space-8) var(--space-12);
}
.fav-page__grid :deep(.poster-card__inner) {
  width: 100%;
  max-width: none;
  min-width: 0;
}

/* ── Empty state — spec §2.7 ── */
.fav-page__empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: var(--space-12) var(--space-8);
  background: var(--color-surface1);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  margin-inline: var(--space-8);
}

.fav-page__empty-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  background: var(--color-surface3);
  border-radius: var(--radius-md);
  color: var(--color-textMuted);
  margin-block-end: 20px;
  flex-shrink: 0;
}

.fav-page__empty-heading {
  margin: 0;
  margin-block-end: var(--space-2);
  font-size: 20px;
  font-weight: 700;
  line-height: 1.3;
  color: var(--color-text);
  font-family: var(--font-hebrew);
}

.fav-page__empty-body {
  margin: 0;
  margin-block-end: 24px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  color: var(--color-textMuted);
  font-family: var(--font-hebrew);
}

/* ── Mobile ── */
@media (max-width: 640px) {
  .fav-page__title {
    font-size: 22px;
    padding-inline: var(--space-4);
  }

  .fav-page__grid {
    padding: var(--space-3) var(--space-4) var(--space-8);
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: var(--space-3);
  }

  .fav-page__empty {
    margin-inline: var(--space-4);
  }
}
</style>
